import { observer } from "mobx-react-lite"
import { FC, useContext } from "react"
import { useLocation, useNavigate } from "react-router-dom";
import { Context } from "../../..";
import { LOCALES } from "../../../core/i18n/locales";

import { FormattedMessage } from "react-intl"

import styles from "../../../styles/Footer.module.scss"
import { StorageKeys } from "../../../core/utils/defaults";

const LoyaltyFooter: FC = () => {

  const { store } = useContext(Context);
  const navigate = useNavigate();
  const location = useLocation();

  const navTo = (event: any) => {
    event.preventDefault();
    event.stopPropagation();

    let url = event.target.pathname || "/";

    if (event.target.tagName.toLowerCase() == "span") {
      url = event.target.parentElement.pathname;
    }

    if (url != location.pathname) {
      console.log(event, url);
  
      store.setIsFaderVisible(true);
      setTimeout(() => {
        store.setIsFaderShown(true);
        setTimeout(() => {
          navigate(url);
        }, 400);
      }, 100);
    }
  }

  const setupLocale = (locale: string) => {
    store.setLocale(locale)
    localStorage.setItem(StorageKeys.LOCALE, locale)
  }
  
  return (
    <>
      <div className={styles.section_footer} id="footer" style={{opacity: store.isAuth ? "1" : "1"}}>
        <div className="container">
          <div className="row">
            
            <div className="col-12">
              <div className={styles.copys}>
                <div className="row">
                  <div className="col-12 col-md-6">
                    <div className={styles.copys_links}>
                      <a target="_blank" href="https://topgun.plus/uploads/oferta_topgunplus.docx">{store.locale == LOCALES.RUSSIAN ? "Публичная оферта" : "Public offer"}</a>
                      <a target="_blank" href="/privacy"><FormattedMessage id="footer_policy" /></a>
                      {/* <a target="_blank" href="/">Главная страница</a>
                      <a target="_blank" href="/franchise">Франшиза</a> */}
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <div className={styles.copys_links_r}>
                      <div className={styles.copys_links_r_w}>
                        {/* <div className={styles.langs_wrap}>
                          <div className={styles.langs}>
                            <div className={store.locale == LOCALES.RUSSIAN ? styles.active : ""} onClick={() => setupLocale(LOCALES.RUSSIAN)}>RU</div>
                            <div className={store.locale == LOCALES.ENGLISH ? styles.active : ""} onClick={() => setupLocale(LOCALES.ENGLISH)}>EN</div>
                            <div className={store.locale == LOCALES.FRANCE ? styles.active : ""} onClick={() => setupLocale(LOCALES.FRANCE)}>FR</div>
                          </div>
                        </div> */}
                        <div className={styles.txt}><FormattedMessage id="footer_copys" /></div>
                        <div className={styles.txt}>© TOPGUN  2014 — 2024</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  )
}

export default observer(LoyaltyFooter)